export async function getList({commit}) {
  const {data: responseData} = await this.$frontendRepositories.appCategories.index();
  return commit('setList', responseData.data);
}
